export default __webpack_public_path__ + "static/media/urls.7a81ebbb.svg";